module.exports = [
	{
		"value": "",
		"label": "Onbekend"
	},
	{
		"value": "af",
		"label": "Afghanistan"
	},
	{
		"value": "al",
		"label": "Albanië"
	},
	{
		"value": "dz",
		"label": "Algerije"
	},
	{
		"value": "as",
		"label": "Amerikaans-Samoa"
	},
	{
		"value": "ad",
		"label": "Andorra"
	},
	{
		"value": "ao",
		"label": "Angola"
	},
	{
		"value": "ai",
		"label": "Anguilla"
	},
	{
		"value": "aq",
		"label": "Antarctica"
	},
	{
		"value": "ag",
		"label": "Antigua en Barbuda"
	},
	{
		"value": "ar",
		"label": "Argentinië"
	},
	{
		"value": "am",
		"label": "Armenië"
	},
	{
		"value": "aw",
		"label": "Aruba"
	},
	{
		"value": "au",
		"label": "Australië"
	},
	{
		"value": "at",
		"label": "Oostenrijk"
	},
	{
		"value": "az",
		"label": "Azerbeidzjan"
	},
	{
		"value": "bs",
		"label": "Bahama's"
	},
	{
		"value": "bh",
		"label": "Bahrein"
	},
	{
		"value": "bd",
		"label": "Bangladesh"
	},
	{
		"value": "bb",
		"label": "Barbados"
	},
	{
		"value": "by",
		"label": "Belarus; Wit-Rusland"
	},
	{
		"value": "be",
		"label": "België"
	},
	{
		"value": "bz",
		"label": "Belize"
	},
	{
		"value": "bj",
		"label": "Benin"
	},
	{
		"value": "bm",
		"label": "Bermuda"
	},
	{
		"value": "bt",
		"label": "Bhutan"
	},
	{
		"value": "bo",
		"label": "Bolivia"
	},
	{
		"value": "ba",
		"label": "Bosnië en Herzegovina"
	},
	{
		"value": "bw",
		"label": "Botswana"
	},
	{
		"value": "bv",
		"label": "Bouveteiland"
	},
	{
		"value": "br",
		"label": "Brazilië"
	},
	{
		"value": "io",
		"label": "Brits Territorium in de Indische Oceaan"
	},
	{
		"value": "bn",
		"label": "Brunei"
	},
	{
		"value": "bg",
		"label": "Bulgarije"
	},
	{
		"value": "bf",
		"label": "Burkina Faso"
	},
	{
		"value": "bi",
		"label": "Burundi"
	},
	{
		"value": "kh",
		"label": "Cambodja"
	},
	{
		"value": "cm",
		"label": "Kameroen"
	},
	{
		"value": "ca",
		"label": "Canada"
	},
	{
		"value": "cv",
		"label": "Kaapverdië"
	},
	{
		"value": "ky",
		"label": "Caymaneilanden"
	},
	{
		"value": "cf",
		"label": "Centraal-Afrikaanse Republiek"
	},
	{
		"value": "td",
		"label": "Tsjaad"
	},
	{
		"value": "cl",
		"label": "Chili"
	},
	{
		"value": "cn",
		"label": "China"
	},
	{
		"value": "cx",
		"label": "Christmaseiland"
	},
	{
		"value": "cc",
		"label": "Cocoseilanden"
	},
	{
		"value": "co",
		"label": "Colombia"
	},
	{
		"value": "km",
		"label": "Comoren"
	},
	{
		"value": "cg",
		"label": "Congo"
	},
	{
		"value": "cd",
		"label": "Democratische Republiek Congo"
	},
	{
		"value": "ck",
		"label": "Cookeilanden"
	},
	{
		"value": "cr",
		"label": "Costa Rica"
	},
	{
		"value": "ci",
		"label": "Ivoorkust"
	},
	{
		"value": "hr",
		"label": "Kroatië"
	},
	{
		"value": "cu",
		"label": "Cuba"
	},
	{
		"value": "cy",
		"label": "Cyprus"
	},
	{
		"value": "cz",
		"label": "Tsjechië"
	},
	{
		"value": "dk",
		"label": "Denemarken"
	},
	{
		"value": "dj",
		"label": "Djibouti"
	},
	{
		"value": "dm",
		"label": "Dominica"
	},
	{
		"value": "do",
		"label": "Dominicaanse Republiek"
	},
	{
		"value": "tp",
		"label": "TP"
	},
	{
		"value": "ec",
		"label": "Ecuador"
	},
	{
		"value": "eg",
		"label": "Egypte"
	},
	{
		"value": "sv",
		"label": "El Salvador"
	},
	{
		"value": "gq",
		"label": "Equatoriaal-Guinea"
	},
	{
		"value": "er",
		"label": "Eritrea"
	},
	{
		"value": "ee",
		"label": "Estland"
	},
	{
		"value": "et",
		"label": "Ethiopië"
	},
	{
		"value": "fk",
		"label": "Falklandeilanden"
	},
	{
		"value": "fo",
		"label": "Faeröer"
	},
	{
		"value": "fj",
		"label": "Fiji"
	},
	{
		"value": "fi",
		"label": "Finland"
	},
	{
		"value": "fr",
		"label": "Frankrijk"
	},
	{
		"value": "fx",
		"label": "FX"
	},
	{
		"value": "gf",
		"label": "Frans-Guyana"
	},
	{
		"value": "pf",
		"label": "Frans-Polynesië"
	},
	{
		"value": "tf",
		"label": "Franse Gebieden in de zuidelijke Indische Oceaan"
	},
	{
		"value": "ga",
		"label": "Gabon"
	},
	{
		"value": "gm",
		"label": "Gambia"
	},
	{
		"value": "ge",
		"label": "Georgië"
	},
	{
		"value": "de",
		"label": "Duitsland"
	},
	{
		"value": "gh",
		"label": "Ghana"
	},
	{
		"value": "gi",
		"label": "Gibraltar"
	},
	{
		"value": "gr",
		"label": "Griekenland"
	},
	{
		"value": "gl",
		"label": "Groenland"
	},
	{
		"value": "gd",
		"label": "Grenada"
	},
	{
		"value": "gp",
		"label": "Guadeloupe"
	},
	{
		"value": "gu",
		"label": "Guam"
	},
	{
		"value": "gt",
		"label": "Guatemala"
	},
	{
		"value": "gn",
		"label": "Guinee"
	},
	{
		"value": "gw",
		"label": "Guinee-Bissau"
	},
	{
		"value": "gy",
		"label": "Guyana"
	},
	{
		"value": "ht",
		"label": "Haïti"
	},
	{
		"value": "hm",
		"label": "Heard- en McDonaldeilanden"
	},
	{
		"value": "va",
		"label": "Vaticaanstad"
	},
	{
		"value": "hn",
		"label": "Honduras"
	},
	{
		"value": "hk",
		"label": "Hongkong"
	},
	{
		"value": "hu",
		"label": "Hongarije"
	},
	{
		"value": "is",
		"label": "IJsland"
	},
	{
		"value": "in",
		"label": "India"
	},
	{
		"value": "id",
		"label": "Indonesië"
	},
	{
		"value": "ir",
		"label": "Iran"
	},
	{
		"value": "iq",
		"label": "Irak"
	},
	{
		"value": "ie",
		"label": "Ierland"
	},
	{
		"value": "il",
		"label": "Israël"
	},
	{
		"value": "it",
		"label": "Italië"
	},
	{
		"value": "jm",
		"label": "Jamaica"
	},
	{
		"value": "jp",
		"label": "Japan"
	},
	{
		"value": "jo",
		"label": "Jordanië"
	},
	{
		"value": "kz",
		"label": "Kazachstan"
	},
	{
		"value": "ke",
		"label": "Kenia; Kenya"
	},
	{
		"value": "ki",
		"label": "Kiribati"
	},
	{
		"value": "kp",
		"label": "Noord-Korea"
	},
	{
		"value": "kr",
		"label": "Zuid-Korea"
	},
	{
		"value": "kw",
		"label": "Koeweit"
	},
	{
		"value": "kg",
		"label": "Kirgizië; Kirgizstan"
	},
	{
		"value": "la",
		"label": "Laos"
	},
	{
		"value": "lv",
		"label": "Letland"
	},
	{
		"value": "lb",
		"label": "Libanon"
	},
	{
		"value": "ls",
		"label": "Lesotho"
	},
	{
		"value": "lr",
		"label": "Liberia"
	},
	{
		"value": "ly",
		"label": "Libië"
	},
	{
		"value": "li",
		"label": "Liechtenstein"
	},
	{
		"value": "lt",
		"label": "Litouwen"
	},
	{
		"value": "lu",
		"label": "Luxemburg"
	},
	{
		"value": "mo",
		"label": "Macau"
	},
	{
		"value": "mk",
		"label": "Voormalige Joegoslavische Republiek Macedonië"
	},
	{
		"value": "mg",
		"label": "Madagaskar"
	},
	{
		"value": "mw",
		"label": "Malawi"
	},
	{
		"value": "my",
		"label": "Maleisië"
	},
	{
		"value": "mv",
		"label": "Maldiven"
	},
	{
		"value": "ml",
		"label": "Mali"
	},
	{
		"value": "mt",
		"label": "Malta"
	},
	{
		"value": "mh",
		"label": "Marshalleilanden"
	},
	{
		"value": "mq",
		"label": "Martinique"
	},
	{
		"value": "mr",
		"label": "Mauritanië"
	},
	{
		"value": "mu",
		"label": "Mauritius"
	},
	{
		"value": "yt",
		"label": "Mayotte"
	},
	{
		"value": "mx",
		"label": "Mexico"
	},
	{
		"value": "fm",
		"label": "Micronesia"
	},
	{
		"value": "md",
		"label": "Moldavië"
	},
	{
		"value": "mc",
		"label": "Monaco"
	},
	{
		"value": "mn",
		"label": "Mongolië"
	},
	{
		"value": "ms",
		"label": "Montserrat"
	},
	{
		"value": "ma",
		"label": "Marokko"
	},
	{
		"value": "mz",
		"label": "Mozambique"
	},
	{
		"value": "mm",
		"label": "Myanmar"
	},
	{
		"value": "na",
		"label": "Namibië"
	},
	{
		"value": "nr",
		"label": "Nauru"
	},
	{
		"value": "np",
		"label": "Nepal"
	},
	{
		"value": "nl",
		"label": "Nederland"
	},
	{
		"value": "an",
		"label": "Nederlandse Antillen"
	},
	{
		"value": "nc",
		"label": "Nieuw-Caledonië"
	},
	{
		"value": "nz",
		"label": "Nieuw-Zeeland"
	},
	{
		"value": "ni",
		"label": "Nicaragua"
	},
	{
		"value": "ne",
		"label": "Niger"
	},
	{
		"value": "ng",
		"label": "Nigeria"
	},
	{
		"value": "nu",
		"label": "Niue"
	},
	{
		"value": "nf",
		"label": "Norfolkeiland"
	},
	{
		"value": "mp",
		"label": "Noordelijke Marianen"
	},
	{
		"value": "no",
		"label": "Noorwegen"
	},
	{
		"value": "om",
		"label": "Oman"
	},
	{
		"value": "pk",
		"label": "Pakistan"
	},
	{
		"value": "pw",
		"label": "Palau"
	},
	{
		"value": "ps",
		"label": "PS"
	},
	{
		"value": "pa",
		"label": "Panama"
	},
	{
		"value": "pg",
		"label": "Papoea-Nieuw-Guinea"
	},
	{
		"value": "py",
		"label": "Paraguay"
	},
	{
		"value": "pe",
		"label": "Peru"
	},
	{
		"value": "ph",
		"label": "Filipijnen"
	},
	{
		"value": "pn",
		"label": "Pitcairneilanden"
	},
	{
		"value": "pl",
		"label": "Polen"
	},
	{
		"value": "pt",
		"label": "Portugal"
	},
	{
		"value": "pr",
		"label": "Puerto Rico; Porto Rico"
	},
	{
		"value": "qa",
		"label": "Qatar"
	},
	{
		"value": "re",
		"label": "Réunion"
	},
	{
		"value": "ro",
		"label": "Roemenië"
	},
	{
		"value": "ru",
		"label": "Rusland"
	},
	{
		"value": "rw",
		"label": "Rwanda"
	},
	{
		"value": "kn",
		"label": "Saint Kitts en Nevis"
	},
	{
		"value": "lc",
		"label": "Saint Lucia"
	},
	{
		"value": "vc",
		"label": "Saint Vincent en de Grenadines"
	},
	{
		"value": "ws",
		"label": "Samoa"
	},
	{
		"value": "sm",
		"label": "San Marino"
	},
	{
		"value": "st",
		"label": "Sao Tomé en Principe"
	},
	{
		"value": "sa",
		"label": "Saudi-Arabië; Saoedi-Arabië"
	},
	{
		"value": "sn",
		"label": "Senegal"
	},
	{
		"value": "sc",
		"label": "Seychellen"
	},
	{
		"value": "sl",
		"label": "Sierra Leone"
	},
	{
		"value": "sg",
		"label": "Singapore"
	},
	{
		"value": "sk",
		"label": "Slowakije; Slovakije"
	},
	{
		"value": "si",
		"label": "Slovenië"
	},
	{
		"value": "sb",
		"label": "Salomonseilanden"
	},
	{
		"value": "so",
		"label": "Somalië"
	},
	{
		"value": "za",
		"label": "Zuid-Afrika"
	},
	{
		"value": "gs",
		"label": "Zuid-Georgië en Zuidelijke Sandwicheilanden"
	},
	{
		"value": "es",
		"label": "Spanje"
	},
	{
		"value": "lk",
		"label": "Sri Lanka"
	},
	{
		"value": "sh",
		"label": "Sint-Helena"
	},
	{
		"value": "pm",
		"label": "Saint-Pierre en Miquelon"
	},
	{
		"value": "sd",
		"label": "Sudan; Soedan"
	},
	{
		"value": "sr",
		"label": "Suriname"
	},
	{
		"value": "sj",
		"label": "Svalbard en Jan Mayen"
	},
	{
		"value": "sz",
		"label": "Swaziland"
	},
	{
		"value": "se",
		"label": "Zweden"
	},
	{
		"value": "ch",
		"label": "Zwitserland"
	},
	{
		"value": "sy",
		"label": "Syrië"
	},
	{
		"value": "tw",
		"label": "Taiwan"
	},
	{
		"value": "tj",
		"label": "Tadzjikistan"
	},
	{
		"value": "tz",
		"label": "Tanzania"
	},
	{
		"value": "th",
		"label": "Thailand"
	},
	{
		"value": "tg",
		"label": "Togo"
	},
	{
		"value": "tk",
		"label": "Tokelau-eilanden"
	},
	{
		"value": "to",
		"label": "Tonga"
	},
	{
		"value": "tt",
		"label": "Trinidad en Tobago"
	},
	{
		"value": "tn",
		"label": "Tunesië"
	},
	{
		"value": "tr",
		"label": "Turkije"
	},
	{
		"value": "tm",
		"label": "Turkmenistan"
	},
	{
		"value": "tc",
		"label": "Turks- en Caicoseilanden"
	},
	{
		"value": "tv",
		"label": "Tuvalu"
	},
	{
		"value": "ug",
		"label": "Uganda; Oeganda"
	},
	{
		"value": "ua",
		"label": "Oekraïne"
	},
	{
		"value": "ae",
		"label": "Verenigde Arabische Emiraten"
	},
	{
		"value": "gb",
		"label": "Verenigd Koninkrijk"
	},
	{
		"value": "us",
		"label": "Verenigde Staten"
	},
	{
		"value": "um",
		"label": "Amerikaanse ondergeschikte afgelegen eilanden"
	},
	{
		"value": "uy",
		"label": "Uruguay"
	},
	{
		"value": "uz",
		"label": "Oezbekistan"
	},
	{
		"value": "vu",
		"label": "Vanuatu"
	},
	{
		"value": "ve",
		"label": "Venezuela"
	},
	{
		"value": "vn",
		"label": "Vietnam"
	},
	{
		"value": "vg",
		"label": "Britse Maagdeneilanden"
	},
	{
		"value": "vi",
		"label": "Amerikaanse Maagdeneilanden"
	},
	{
		"value": "wf",
		"label": "Wallis en Futuna"
	},
	{
		"value": "eh",
		"label": "Westelijke Sahara"
	},
	{
		"value": "ye",
		"label": "Jemen"
	},
	{
		"value": "yu",
		"label": "Joegoslavië"
	},
	{
		"value": "zm",
		"label": "Zambia"
	},
	{
		"value": "zw",
		"label": "Zimbabwe"
	}
];


//////////////////
// WEBPACK FOOTER
// ./js/modules/constants/CountryOptions.json
// module id = 36
// module chunks = 0